module.exports = __webpack_public_path__ + "img/Icon_Facebook.9942bd7b.svg";